import React, { useState } from "react";

import "./filterconfirmation.scss";

const FilterConfirmation = (props:any) => {
const [activeIndex, setActiveIndex] = useState(null);
const [isDisabled, setIsDisabled] = useState(false);
 const [intitialClassName, setClassName] = useState("option-button");
  const [selectedOption, setSelectedOption] = useState("");

  const suboptions = [
    {
      text: "Yes",
      handler: props.actionProvider.showFilter,
      id: 1,
    },
    {
      text: "No",
      handler: props.actionProvider.handleFilter,
      id: 2,
    },
  ];

  const buttonsMarkup = suboptions.map((option:any,index:any) => (
    <React.Fragment key={option.id}>
      <button 
        onClick={()=>{
          setIsDisabled(!isDisabled);
          setActiveIndex(index);
          setSelectedOption(option.text);
          option.handler();
          setClassName("option-inactive");
        }} 
        className={activeIndex === index?"change-buttons":intitialClassName} 
        disabled={isDisabled}
        aria-pressed={activeIndex === index}
      >
        {option.text}
      </button>
    </React.Fragment>
  ));

  return (
    <div className="options-container" role="group" aria-label="Filter confirmation options">
      {buttonsMarkup}
      {selectedOption && (
        <div aria-live="polite" className="sr-only">
          Selected: {selectedOption}
        </div>
      )}
    </div>
  );
};

export default FilterConfirmation;
